module.exports = __webpack_public_path__ + "static/media/Close cr-fr 1.3aa269a5.svg";